"use client"
import { IconCircleFilled } from "@tabler/icons-react"
import { observer, reactive, useObservable } from "@legendapp/state/react"
import { syncStore$ } from "@/stores/sync.v2.store"
import { MenuItem, Text } from "@mantine/core"
import { useTransition } from "react"
import { actionChangeAvailability } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile/components/MenuItemChangeAvailabilityButton/actions"
import { showNotification } from "@/lib/notifications"

const ReactiveIconCircleFilled = reactive(IconCircleFilled)

export const MenuItemChangeAvailabilityButton = observer(function MenuItemChangeAvailabilityButton() {
  const [isPending, startTransition] = useTransition()
  const isCheckedIn$ = useObservable(() => syncStore$.userStatus.checkedIn.get() ?? false)

  async function toggleCheckedIn() {
    const currentCheckedIn = isCheckedIn$.peek()

    try {
      // Optimistically update the UI
      isCheckedIn$.set(!currentCheckedIn)
      await actionChangeAvailability({
        availability: !currentCheckedIn ? "available" : "away",
      })
    } catch (err) {
      console.error(err)
      // Rollback the UI change
      isCheckedIn$.set(currentCheckedIn)
      showNotification({
        type: "error",
        title: "Error while changing the account availability",
        message: "Try again in a few seconds or reach your administrator for help.",
      })
    }
  }

  return (
    <MenuItem
      disabled={isPending}
      leftSection={<ReactiveIconCircleFilled size={16} $style={{ color: isCheckedIn$.get() ? "var(--mantine-color-green-5)" : "var(--mantine-color-yellow-5)" }} />}
      onClick={() => {
        startTransition(() => {
          toggleCheckedIn()
        })
      }}
    >
      Set as{" "}
      <Text component="span" fw={500} fz={"inherit"}>
        {!isCheckedIn$.get() ? "Available" : "Away"}
      </Text>
    </MenuItem>
  )
})
